import dayjs from 'dayjs';
import React, { useState } from 'react';
import PageTitle from '../../../utils/PageTitle';
import { mkRelativeUrl } from '../../../utils/URL';
import ReportCategoryButton from '../Components/ReportCategoryButton';
import ReportsPageHeader from '../Components/ReportsPageHeader';

function ForecastReportPage() {
    const [formData, setFormData] = useState({
        startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
        endDate: dayjs().endOf('month').format('YYYY-MM-DD')
    });

    const summaryPath = mkRelativeUrl('/reports/forecast/summary', {
        'start-date': formData?.startDate,
        'end-date': formData?.endDate
    });

    const detailsPath = mkRelativeUrl('/reports/forecast/details', {
        'start-date': formData?.startDate,
        'end-date': formData?.endDate
    });

    const applicationWisePath = mkRelativeUrl('/reports/forecast/application', {
        'start-date': formData?.startDate,
        'end-date': formData?.endDate
    });

    const customerWisePath = mkRelativeUrl('/reports/forecast/customer', {
        'start-date': formData?.startDate,
        'end-date': formData?.endDate
    });

    // set page title
    PageTitle(`Forecast Reports`);

    return (
        <div className="inner_page_cont">
            <ReportsPageHeader formData={formData} setFormData={setFormData} />

            <ReportCategoryButton
                summaryPath={summaryPath}
                detailsPath={detailsPath}
                applicationWisePath={applicationWisePath}
                customerWisePath={customerWisePath}
            />
        </div>
    );
}

export default ForecastReportPage;
